/**
 * Compliance Status Badge Component
 *
 * Renders a badge with appropriate styling and icon for compliance status
 */

import { CheckCircle, AlertTriangle, XCircle, Info } from 'lucide-react';
import { Badge } from '@/components/tamagui';
import type { ComplianceStatus } from '@/types/compliance';

interface ComplianceStatusBadgeProps {
  status: ComplianceStatus;
}

export function ComplianceStatusBadge({ status }: ComplianceStatusBadgeProps) {
  switch (status) {
    case 'compliant':
      return (
        <Badge variant="risk" level="low">
          <CheckCircle className="w-3 h-3 mr-1" /> Compliant
        </Badge>
      );
    case 'partial':
      return (
        <Badge variant="risk" level="medium">
          <AlertTriangle className="w-3 h-3 mr-1" /> Partial
        </Badge>
      );
    case 'non-compliant':
      return (
        <Badge variant="risk" level="high">
          <XCircle className="w-3 h-3 mr-1" /> Non-Compliant
        </Badge>
      );
    case 'not-applicable':
      return (
        <Badge variant="risk" level="low">
          <Info className="w-3 h-3 mr-1" /> N/A
        </Badge>
      );
  }
}
